var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFollowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 200 200",
    style: {
      enableBackground: "new 0 0 200 200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M139.5,148.9h-19.2c-3.2,0-5.9,2.6-5.9,5.9s2.6,5.9,5.9,5.9h19.2c3.2,0,5.9-2.6,5.9-5.9S142.7,148.9,139.5,148.9z  M95.2,148.9H28.7c-3.2,0-5.9,2.6-5.9,5.9s2.6,5.9,5.9,5.9h66.5c3.2,0,5.9-2.6,5.9-5.9S98.4,148.9,95.2,148.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M145.3,186.7h-107c-10.5,0-19-8.5-19-19V34.1c0-10.5,8.5-19,19-19h81.9c3.2,0,5.9,2.6,5.9,5.9s-2.6,5.9-5.9,5.9H38.2 c-4,0-7.3,3.3-7.3,7.3v133.5c0,4,3.3,7.3,7.3,7.3h107c4,0,7.3-3.3,7.3-7.3V90.5c0-3.2,2.6-5.9,5.9-5.9c3.2,0,5.9,2.6,5.9,5.9v77.2 C164.3,178.2,155.7,186.7,145.3,186.7L145.3,186.7z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M177.3,23.8l-7.7-7.7c-4.7-4.7-12.7-4.3-17.9,0.9L81.9,86.9l-14.2,38.8l38.8-14.1l69.8-69.8c2.4-2.4,3.8-5.4,4.1-8.6 C180.8,29.6,179.6,26.2,177.3,23.8L177.3,23.8z M100.1,101.4l-12.7,4.6L92,93.3l51.7-51.7l8,8.1L100.1,101.4L100.1,101.4z  M168.1,33.5l-8.1,8.1l-8-8.1l8-8c0.6-0.6,1.2-0.8,1.5-0.8l7.3,7.3C168.8,32.2,168.7,32.9,168.1,33.5L168.1,33.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFollowUp);
export default __webpack_public_path__ + "static/media/followUp.7e6298b2.svg";
export { ForwardRef as ReactComponent };